import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetActionButtons = createAsyncThunk(
  "GetActionButtons",
  async (flow, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowActionRound/GaetAllActionButtons",
        {
          aI_ApplicationInformationId: flow.aI_ApplicationInformationId,
          flowGUID: flow.flowGUID,
          isMainFlow:flow.isMainFlow
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetActionButtons");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ActionButtons = createSlice({
  name: "ActionButtons",
  initialState: {
    ActionButtons: [],
    loadingActionButtons: false,
    errorActionButtons: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetActionButtons.pending, (state, action) => {
        state.loadingActionButtons = true;
        state.ActionButtons = action.payload;
        state.errorActionButtons = null;
      })
      .addCase(GetActionButtons.fulfilled, (state, action) => {
        state.loadingActionButtons = false;
        state.ActionButtons = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetActionButtons.rejected, (state, action) => {
        state.loadingActionButtons = false;
        state.errorActionButtons = action.payload;
      });
  },
});

export default ActionButtons.reducer;
